/* eslint-disable react/no-children-prop */
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { getCampaignDetails, getBannerDetails } from "./requestCall";
import { Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Markdown from "markdown-to-jsx";
import { useParams } from "react-router-dom";

const streamDetailWrapper = css`
  width: 100%;
  background: #121212;
  min-height: 63vh;
`;

const dividerWrapper = (matches) => css`
  display: flex;
  justify-content: space-between;
  margin: 40px ${matches ? "20px" : 0};
  span {
    flex-grow: 2;
    position: relative;
    border-bottom: 1px solid;
    bottom: 14px;
  }
  p {
    margin: 0 20px;
  }
`;
const titleWrapper = (theme) => css`
  font-size: 32px;
  line-height: 32px;
  font-family: ${theme.typography.MBCORPOA};
`;
const detailDescription = (matches) => css`
  margin: 40px 0;
  margin-left: ${matches ? "20px" : 0};
  font-size: 14px;
  line-height: 35px;
`;
const bannerDes = (matches) => css`
  margin-left: ${matches ? "20px" : 0};
  margin-top: 20px;
  font-size: 14px;
  line-height: 35px;
`;
const streamDetailContentWrapper = (matches) => css`
  padding-bottom: 50px;
  margin: 0 ${matches ? 0 : "24%"};
  img,
  video {
    width: 100%;
  }
`;
const textTileHead = css`
  line-height: 36px;
  padding-top: 0;
`;
const markdownDescription = (matches) => css`
  display: block;
  color: #ffffff;
  margin: 40px 0;
  margin-left: ${matches ? "20px" : 0};
  margin-right: ${matches ? "20px" : 0};
`;

const renderBanner = (bannerDetail, bannerDetailItems, textTiles, matches) => {
  return (
    <Box css={() => streamDetailContentWrapper(matches)}>
      {bannerDetail?.map((banner) => {
        return (
          <Box key={banner.id}>
            {banner.bannerVideoSource ? (
              <video
                controls="controls"
                autoPlay
                src={banner.bannerVideoSource}
              />
            ) : (
              banner?.thumbnailImage?.data?.attributes?.url && (
                <img
                  src={`${process.env.REACT_APP_BASEURL}${banner?.thumbnailImage?.data?.attributes?.url}`}
                />
              )
            )}
            {banner?.textTiles?.map((textTile) => (
              <Typography css={() => bannerDes(matches)} key={textTile.id}>
                <Markdown>{textTile.description || ""}</Markdown>
              </Typography>
            ))}
          </Box>
        );
      })}
      <Box>
        {bannerDetailItems?.map((item) => {
          return (
            <Box key={item.id}>
              {item.Title && (
                <DetailItemTitle title={item.Title} matches={matches} />
              )}
              <Typography css={() => detailDescription(matches)}>
                <Markdown>{item.description || ""}</Markdown>
              </Typography>
              {item?.image?.data?.attributes?.url && (
                <img
                  src={`${process.env.REACT_APP_BASEURL}${item?.image?.data?.attributes?.url}`}
                  alt="banner image"
                />
              )}
            </Box>
          );
        })}
      </Box>
      {textTiles?.length > 0 && (
        <Box pt={2}>
          <Typography pt={4} variant="h4" css={textTileHead}>
            {textTiles[0]?.heading}
          </Typography>
          <Markdown css={() => markdownDescription(matches)}>
            {textTiles[0]?.description || ""}
          </Markdown>
        </Box>
      )}
    </Box>
  );
};
const DetailItemTitle = ({ title, matches }) => {
  return (
    title && (
      <Typography css={() => dividerWrapper(matches)}>
        <span></span>
        <Typography css={titleWrapper}>{title}</Typography>
        <span></span>
      </Typography>
    )
  );
};
const renderCampaign = (
  detailItems,
  videoSrc,
  videoDescription,
  videoImage,
  matches
) => {
  return (
    <Box css={() => streamDetailContentWrapper(matches)}>
      <Box>
        {videoSrc ? (
          <video controls="controls" src={videoSrc} />
        ) : (
          videoImage && (
            <img src={`${process.env.REACT_APP_BASEURL}${videoImage}`} />
          )
        )}
        <Typography css={() => bannerDes(matches)}>
          <Markdown>{videoDescription || ""}</Markdown>
        </Typography>
      </Box>
      <Box>
        {detailItems?.map((item) => {
          return (
            <Box key={item.id}>
              {item?.ctaList?.map((rltItem) => (
                <Box key={rltItem.id}>
                  {rltItem.Title && (
                    <DetailItemTitle title={rltItem.Title} matches={matches} />
                  )}
                  <Typography css={() => detailDescription(matches)}>
                    <Markdown>{rltItem.description || ""}</Markdown>
                  </Typography>
                  {rltItem?.image?.data?.attributes?.url && (
                    <img
                      src={`${process.env.REACT_APP_BASEURL}${rltItem?.image?.data?.attributes?.url}`}
                    />
                  )}
                </Box>
              ))}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
const EventAndCampaignDetail = ({ Slug, compName }) => {
  const { slug } = useParams();

  window.scrollTo(0, 0);
  const pathname = window.location.pathname;
  let isBanner = pathname.indexOf("/general-detail-pages/") > -1;
  // let id = isBanner
  //   ? pathname.replace("/general-detail-pages/", "")
  //   : pathname.replace("/news/events-and-campaigns/", "");
  if (pathname === "/api/preview") {
    // id = null;
    isBanner = compName === "generalDetailPages";
  }
  const [detailItems, setDetailItems] = useState();
  const [bannerDetail, setBannerDetail] = useState();
  const [bannerDetailItems, setBannerDetailItems] = useState();
  const [videoSrc, setVideoSrc] = useState("");
  const [videoDescription, setVideoDescription] = useState("");
  const [videoImage, setVideoImage] = useState("");
  const [textTiles, setTexTiles] = useState("");
  const matches = useMediaQuery("(max-width: 415px)");

  useEffect(() => {
    if (isBanner) {
      getBannerDetails(slug || Slug).then((res) => {
        const banner = res?.data?.data?.attributes?.body?.filter(
          (item) =>
            item.__component === "components.banner-image-with-text-tiles"
        );
        setBannerDetail(banner);
        const bannerItems = res?.data?.data?.attributes?.body?.filter(
          (item) => item.__component === "shared.call-to-action"
        );
        setBannerDetailItems(bannerItems);
        const textTilesOnly = res?.data?.data?.attributes?.body?.filter(
          (item) => item.__component === "shared.text-tiles"
        );
        setTexTiles(textTilesOnly);
      });
    } else {
      getCampaignDetails(slug || Slug).then((res) => {
        setDetailItems(res?.data?.data?.attributes?.body);
        setVideoSrc(res?.data?.data?.attributes?.videoSource);
        setVideoDescription(res?.data?.data?.attributes?.description);
        setVideoImage(
          res?.data?.data?.attributes?.thumbnailImage?.data?.attributes?.url
        );
      });
    }
  }, []);

  return (
    <Box css={streamDetailWrapper}>
      {isBanner
        ? renderBanner(bannerDetail, bannerDetailItems, textTiles, matches)
        : renderCampaign(
            detailItems,
            videoSrc,
            videoDescription,
            videoImage,
            matches
          )}
    </Box>
  );
};
export default EventAndCampaignDetail;
